import React from 'react';

const Impact: React.FC = () => {
  const stats = [
    { number: '800+', label: 'Lives Impacted' },
    { number: '12+', label: 'Education Programs' },
    { number: '23', label: 'Healthcare Initiatives' },
    { number: '5', label: 'Years of Service' }
  ];

  return (
    <section id="impact" className="py-16 bg-gradient-to-br from-primary to-secondary text-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-4xl sm:text-4xl md:text-4xl font-bold mb-6">Our Impact So Far</h2>
          <div className="w-20 h-1 bg-white/50 mx-auto"></div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-8">
          {stats.map((stat, index) => (
            <div key={index} className="text-center p-4 md:p-6 bg-white/10 rounded-lg backdrop-blur-sm">
              <div className="text-3xl md:text-5xl font-bold mb-2">{stat.number}</div>
              <div className="text-sm md:text-lg opacity-90">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Impact;
